import React from "react";
import InvalidSlackEmailsList from "./InvalidSlackEmailsList";

export default function InvalidSlackEmailsPage() {
  return (
    <div className="invalid-slack-emails-page-container">
      <React.Suspense fallback="Loading slack emails...">
        <InvalidSlackEmailsList />
      </React.Suspense>
    </div>
  );
}
